<template>
  <div class="accountFooter" :class="{ 'accountFooter--collapsed': collapsed }">
    <div class="accountFooter__user" :title="userName" @click="openCabinet">
      <span class="accountFooter__avatar">{{ initial }}</span>
      <span v-if="!collapsed" class="accountFooter__rest">{{ rest }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth.js'
import { useAccountCabinet } from '@/composables/useAccountCabinet.js'

defineProps({
  collapsed: { type: Boolean, default: false },
})

const auth = useAuthStore()
const cabinet = useAccountCabinet()

const userName = computed(() => auth.user?.name || auth.user?.login || '')
const initial = computed(() => {
  const n = (userName.value || '').trim()
  return n ? n[0].toUpperCase() : '?'
})
const rest = computed(() => {
  const n = (userName.value || '').trim()
  return n.length > 1 ? n.slice(1) : ''
})

function openCabinet() { cabinet.open() }
</script>

<style scoped lang="scss">
.accountFooter {
  flex: 0 0 auto;
  margin-top: auto;
  border-top: 1px solid #f0e2b8;
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.accountFooter__user {
  display: flex;
  align-items: center;
  gap: 0;
  min-width: 0;
  font-size: 13px;
  color: #555;
  cursor: pointer;
}
.accountFooter__user:hover { color: var(--el-color-primary); }
.accountFooter__avatar {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #ffbf1f;
  background: #fdf6e3;
  color: #b8860b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.accountFooter__rest {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accountFooter--collapsed {
  align-items: center;
  padding: 8px 0;
}
.accountFooter--collapsed .accountFooter__user {
  justify-content: center;
}
</style>
